import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

@Directive(
    {
        selector: '[YearCustomValidation]',
        providers: [{ provide: NG_VALIDATORS, useExisting: YearCustomValidation, multi: true }]
    }
)
export class YearCustomValidation {
    @Input("YearCustomValidation")
    InsuredId: string;
    Test1: string;

    validate(v: FormControl) {
        let c = v.value;

        let Currentdate = new Date();
        let CurrentYear = Currentdate.getFullYear();
       // alert(this.InsuredId)
        if (this.InsuredId.substring(0, 1) == "1") {
            if (c > 1522) {
                return { "YearCustomValidation": true };
            }
        }
        else if (this.InsuredId.substring(0, 1) == "2") {
            if (c > CurrentYear || c < 1900) {
                return { "YearCustomValidation": true };
            }
        }

    }

} 



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Directives/YearCustomValidation.ts